import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect } from "react";


export default function DropDownField ({ label, value, options, onHandleStyleChange }) {
    
    return (
        <div>
            {/* <label>{options[0]}</label> */}
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{label}</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                label={label}
                onChange={(e)=>onHandleStyleChange(e.target.value)}
                >
                {options.map((option, index) => (
                    <MenuItem value={option} key={index} >{option}</MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    )
}